// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch {
    width: 40px;
    height: 20px;
    display: flex;
    justify-content: flex-start;
    border-radius: 40px;
    padding: 2px;
}

.switch[data-isOn="true"] {
    justify-content: flex-end;
}

.switch[data-isOn="2"] {
    justify-content: center;
}

.handle {
    width: 16px;
    height: 16px;
    border-radius: 40px;
}

.parent {
    background: rgb(117, 103, 197);
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.parent[data-isOpen="true"] {
    width: 400px;
    height: 200px;
}

.child {
    width: 40px;
    height: 40px;
    background: #f107a3;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Vam30Users/css/css.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".switch {\n    width: 40px;\n    height: 20px;\n    display: flex;\n    justify-content: flex-start;\n    border-radius: 40px;\n    padding: 2px;\n}\n\n.switch[data-isOn=\"true\"] {\n    justify-content: flex-end;\n}\n\n.switch[data-isOn=\"2\"] {\n    justify-content: center;\n}\n\n.handle {\n    width: 16px;\n    height: 16px;\n    border-radius: 40px;\n}\n\n.parent {\n    background: rgb(117, 103, 197);\n    width: 100px;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.parent[data-isOpen=\"true\"] {\n    width: 400px;\n    height: 200px;\n}\n\n.child {\n    width: 40px;\n    height: 40px;\n    background: #f107a3;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
